0
<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2 class="text-white">
					اپلیکیشن تسکینو
					<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<!-- Button trigger modal -->
				<button type="button" style="display:none" class="btn btn-primary" id="btnShowModal" data-toggle="modal" data-target="#exampleModalCenter">
					Launch demo modal
				</button>
				<!--<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center"><i class="font-22 fa fa-bars"></i></button>-->
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="" data-card-height="210" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
				<div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
				<div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
				<div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
			</div>
			<div class="card card-style">
				<div class="content">
					<img src="/assets/images/slides/slide-02.jpg" />
				</div>
			</div>
			<div class="card bg-20 mt-4">
				<div class="card-body">
					<h2 class="color-white text-center mt-3">راهکاری فوق العاده برای </h2>
					<!--<button class="simulate-android-badge bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center"><i class="font-16 fa fa-comment"></i></button>-->
					<h2 class="color-white text-center">برای برنامه ریزی و مدیریت کارها</h2>
					<p class="color-white font-16 mt-3 text-center">
						این اپلیکیشن ثبت و برنامه ریزی وظایف و کارها به صورت روزانه، دوره ای با امکان یادآوری و زمانبندی و بسیاری امکانات و قابلیت های دیگر را برای شما فراهم می کند.
					</p>
					<p class="color-white font-16 mt-3 text-center">
						برای آشنایی با امکانات و قابلیت های این اپلیکشین ویدیوی زیر را مشاهده کنید.
					</p>
				</div>
				<div class="card-overlay bg-magenta2-dark opacity-85"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<div class="card card-style">
				<div class="content text-center">
					<video class="responsive-video" controls preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
						<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro.mp4" type="video/mp4">
					</video>
				</div>
			</div>


			<!--<div class="double-slider text-center owl-carousel owl-no-dots mb-4">
			<router-link class="item bg-white rounded-m shadow-m d-block" to="/CreateTask">
				<i class="fa fa-check-circle mt-4 mb-4 font-40 color-green2-light"></i>
				<h5 class="font-16">ثبت <span v-if="TaskAccess=='1'">{{lableText('TasksName')??'پروژه'}}</span></h5>
				<p class="line-height-s font-11">
					به صورت روزانه <br>و دوره ای
				</p>
			</router-link>
			<router-link class="item bg-white rounded-m shadow-m d-block" to="/CreateOtherWork">
				<i class="far fa-list-alt mt-4 mb-4 font-40 color-pink2-light"></i>
				<h5 class="font-16">ثبت فعالیت ها</h5>
				<p class="line-height-s font-11">
					به صورت شخصی  <br>و تیمی
				</p>
			</router-link>
			<router-link class="item bg-white rounded-m shadow-m d-block" to="/CreateCheckList">
				<i class="fa fa-list mt-4 mb-4 font-40 color-magenta1-dark"></i>
				<h5 class="font-16">ثبت چک لیست</h5>
				<p class="line-height-s font-11">
					همراه با یادآور <br> به صورت SMS
				</p>
			</router-link>
			<router-link class="item bg-white rounded-m shadow-m d-block" to="/CreateReminder">
				<i class="fa fa-bell mt-4 mb-4 font-40 color-yellow1-light"></i>
				<h5 class="font-16">ثبت یادآور</h5>
				<p class="line-height-s font-11">
					با ارسال <br> SMS
				</p>
			</router-link>
			<router-link class="item bg-white rounded-m shadow-m d-block" to="/CreateUserPresence">
				<i class="fa fa-street-view mt-4 mb-4 font-40 color-pink2-light"></i>
				<h5 class="font-16">حضور و غیاب</h5>
				<p class="line-height-s font-11">
					ثبت لوکیشن <br> آنلاین
				</p>
			</router-link>
		</div>-->

		</div>

		<!--<div class="add-to-home">
		<h1 class="my-2 font-14">عنوان نوتیفیکیشن</h1>
		<p>
			برای آشنایی با امکانات و قابلیت های این اپلیکشین ویدیوی زیر را مشاهده کنید.
		</p>
		<i class="fa fa-bell icon color-green1-dark"></i>
		<i class="fa fa-caret-up"></i>
		<button class="close-add-to-home btn btn-link"><i class="fa fa-times-circle color-red2-dark"></i></button>
	</div>-->




		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
	</div>
	<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center">
					<span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">پیام ها</span>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body m-0 pb-0">
					<div :id="item.randonId" v-for="item in NoticeMessageList" :key="item.noticeMessageId">
						<div class="border-1 p-3 mb-3">
							<p class="font-weight-bold mb-2 font-16 line-height-l text-justify">
								<i class="fa fa-exclamation-triangle text-warning ml-2"></i>
								{{item.title}}
							</p>
							<p class="card-text mb-2 line-height-m font-14 text-justify" v-html="item.description"></p>
							<div class="text-left">
								<button @click="IRealized(item)"  type="button" class="btn btn-xs btn-success font-weight-bold"><i class="fa fa-check font-10 ml-2"></i>متوجه شدم</button>
								<a target="_blank" :href="item.mobileUrl" v-if="!!item.mobileUrl" type="button" class="btn mx-1 btn-xs btn-warning font-weight-bold text-white"><i class="fa fa-check font-10 ml-2"></i>هدایت به لینک</a>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//import { initializeApp } from "firebase/app";
	//import { getMessaging, onMessage, getToken } from "firebase/messaging";
    import HelpMenu from '../Components/HelpMenu.vue';
	export default {
        components: {
            "Help-Menu": HelpMenu
        },
		computed: {
			TaskAccess() {
				return this.$store.getters.GetTaskAccess;
			},
			NoticeMessageList() {
				var list = this.$store.getters.GetNoticeMessageList;
				var btnShowModal = document.getElementById("btnShowModal");
				if (list.length > 0)
					btnShowModal?.click();
				return list;
			},
		},
		created() {

			this.$store.dispatch("GetNoticeMessageListFromServer", {});
		},
		methods: {
			IRealized(item) {
				if (item.isNoticeMessage) {
					this.$http
                        .get("TaskOnline/ViewNoticeMessage2?id=" + item.noticeMessageId)
						.then((data) => {
							var res = data.data;
							if (res.isSuccess) {
								this.showSuccessMessage(res.message);
                                document.getElementById(item.randonId).innerHTML = "";
							} else {
								this.showErrorMessage(res.message);
							}
						});

				} else {
                    this.$http
                        .get("TaskOnline/ViewNoticeMessage?id=" + item.noticeId)
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                this.showSuccessMessage(res.message);
                                document.getElementById(item.randonId).innerHTML = "";
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });	
				}
			},
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {

			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},

	};
</script>



